<template>
  <layout-login>
    <p class="invite-text">
      {{ inviteuser }} {{ $t('message["1588"]') }}
    </p>
    <h2 class="invite-company-desc">
      <p v-text="comname" />
      <!-- 并成为该组织管理员 -->
    </h2>
    <p class="invite-text">
      {{ $t('message["1096"]') }}
    </p>
    <div class="join-btn">
      <cube-button
        type="submit"
        :primary="true"
        @click="handleJoin"
      >
        {{ $t('message["597"]') }}
      </cube-button>
      <p
        class="invite-after"
        @click="afterJoin"
      >
        {{ $t('message["1448"]') }}
      </p>
    </div>
  </layout-login>
</template>

<script type="text/ecmascript-6">
import LayoutLogin from '@/components/mobile/account/LayoutLogin'
import { mapActions } from 'vuex'
export default {
  components: {
    LayoutLogin
  },
  data () {
    return {
    }
  },
  computed: {
    comname () {
      return this.$route.query.comname
    },
    inviteuser () {
      return this.$route.query.inviteuser
    },
    invitecode () {
      return this.$route.query.invitecode
    }
  },
  methods: {
    ...mapActions('organization/inviteJoin', ['ajaxLastJoin']),
    async handleJoin () {
      const chain = await this.ajaxLastJoin()
      chain.params({ invitecode: this.invitecode })
        .onSuccess((raw, res) => {
          this.$router.push({ name: 'OrgIndex' })
        })
        .fetch()
    },
    afterJoin () {
      this.$router.push({ name: 'OrgIndex' })
    }
  }
}
</script>

<style scoped lang="scss">
.invite-text {
  width: 327px;
  color: #888;
  line-height: 23px;
  font-size: 15px;
  text-align: center;
}
.invite-company-desc {
  width: 280px;
  text-align: center;
  color: #000;
  line-height: 28px;
  font-size: 18px;
  font-weight: 400;
  margin: 18px auto 12px auto
}
.join-btn {
  margin: 46px 0;
}
.invite-after {
  font-size: 14px;
  line-height: 14px;
  color: #5077AA;
  margin: 36px 0
}
</style>
